import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import RotaProtegida from './auth/RotaProtegida'
import Layout from './componentes/Layout'
import LimiteDeErro from './componentes/LimiteDeErro'
import JanelaConfirmacao from './componentes/JanelaConfirmacao'
import Login from './paginas/Login'
import Cadastro from './paginas/Cadastro'
import EsqueciSenha from './paginas/EsqueciSenha'
import NovaSenha from './paginas/NovaSenha'
import Painel from './paginas/Painel'
import Mais from './paginas/Mais'
import Ajuda from './paginas/Ajuda'
import AgendaDia from './paginas/agenda/AgendaDia'
import MontarRota from './paginas/agenda/MontarRota'
import ListaRepresentadas from './paginas/representadas/ListaRepresentadas'
import FormRepresentada from './paginas/representadas/FormRepresentada'
import EdicaoTabelaPreco from './paginas/representadas/EdicaoTabelaPreco'
import PercentuaisDaRegra from './paginas/representadas/PercentuaisDaRegra'
import ListaClientes from './paginas/clientes/ListaClientes'
import FormCliente from './paginas/clientes/FormCliente'
import ListaProdutos from './paginas/produtos/ListaProdutos'
import FormProduto from './paginas/produtos/FormProduto'
import HistoricoDoCliente from './paginas/produtos/HistoricoDoCliente'
import ImportarArquivo from './paginas/importacao/ImportarArquivo'
import HistoricoImportacoes from './paginas/importacao/HistoricoImportacoes'
import ListaPedidos from './paginas/pedidos/ListaPedidos'
import PedidoRoteador from './paginas/pedidos/PedidoRoteador'
import TelaPedido from './paginas/pedidos/TelaPedido'
import FecharPedido from './paginas/pedidos/FecharPedido'
import EnviarPedido from './paginas/pedidos/EnviarPedido'
import PreviaEnvio from './paginas/pedidos/PreviaEnvio'
import MeusCompromissos from './paginas/compromissos/MeusCompromissos'
import FormCompromisso from './paginas/compromissos/FormCompromisso'
import Metas from './paginas/metas/Metas'
import CriadorDeMetas from './paginas/metas/CriadorDeMetas'
import RepetirMetas from './paginas/metas/RepetirMetas'
import EmAndamento from './paginas/metas/EmAndamento'
import ConfiguracaoMetas from './paginas/config/ConfiguracaoMetas'
import MeuPerfil from './paginas/config/MeuPerfil'
import IndiqueEGanhe from './paginas/IndiqueEGanhe'
import Comissoes from './paginas/comissoes/Comissoes'
import ConferenciaFornecedora from './paginas/comissoes/ConferenciaFornecedora'
import NaoSubiram from './paginas/sync/NaoSubiram'

// F1 (revisao final, 26/09): /representadas/nova e /representadas/:id
// renderizavam o MESMO <FormRepresentada/> na mesma posicao da arvore, e o
// React reaproveitava a instancia -- `editando`, a aba aberta e os rascunhos
// de condicao/comissao sobreviviam a criacao de uma fornecedora nova, que
// ficava presa no formulario de criacao em vez de abrir em visualizacao. Um
// componente proprio para a rota com :id, com `key={id}`, forca o remount
// tanto na troca nova->existente (tipo do elemento muda) quanto ao navegar
// direto entre duas fornecedoras existentes (a key muda).
function FormRepresentadaExistente() {
  const { id } = useParams()
  return <FormRepresentada key={id} />
}

export default function App() {
  return (
    // O limite fica no TOPO, e nao em volta de cada tela: erro no Layout, no
    // roteador ou no provedor de sessao tambem tem de virar mensagem legivel em
    // vez de tela branca -- e foi um erro DENTRO de uma tela que mostrou, em
    // 18/08/2026, que sem isto o app inteiro desaparece.
    <LimiteDeErro>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            {/* As duas do "esqueci minha senha" ficam FORA da area protegida de
                proposito: com o link vencido nao existe sessao, e la dentro a
                pessoa seria mandada para /login sem nunca ler o motivo. */}
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/nova-senha" element={<NovaSenha />} />
            <Route element={<RotaProtegida />}>
              <Route element={<Layout />}>
                <Route path="/" element={<Painel />} />
                <Route path="/agenda" element={<AgendaDia />} />
                <Route path="/agenda/montar" element={<MontarRota />} />
                <Route path="/mais" element={<Mais />} />
                {/* Rota funda de proposito: assim ela ganha o botao Voltar do
                    Layout de graca, sem tocar em RAIZES nem numa sexta aba, que
                    deixaria os rotulos da barra ilegiveis num celular de 360px. */}
                <Route path="/ajuda" element={<Ajuda />} />
                <Route path="/representadas" element={<ListaRepresentadas />} />
                <Route path="/representadas/nova" element={<FormRepresentada />} />
                <Route path="/representadas/:id" element={<FormRepresentadaExistente />} />
                <Route path="/representadas/:id/comissao/:regraId/percentuais" element={<PercentuaisDaRegra />} />
                <Route path="/tabelas/:id" element={<EdicaoTabelaPreco />} />
                <Route path="/clientes" element={<ListaClientes />} />
                <Route path="/clientes/novo" element={<FormCliente />} />
                <Route path="/clientes/:id" element={<FormCliente />} />
                <Route path="/produtos" element={<ListaProdutos />} />
                <Route path="/produtos/novo" element={<FormProduto />} />
                <Route path="/produtos/:id" element={<FormProduto />} />
                <Route path="/produtos/:id/clientes/:clienteId" element={<HistoricoDoCliente />} />
                <Route path="/importar" element={<ImportarArquivo />} />
                <Route path="/importacoes" element={<HistoricoImportacoes />} />
                <Route path="/pedidos" element={<ListaPedidos />} />
                <Route path="/pedidos/:id" element={<PedidoRoteador />} />
                <Route path="/pedidos/:id/acrescentar" element={<TelaPedido acrescentando />} />
                <Route path="/pedidos/:id/enviar" element={<EnviarPedido />} />
                <Route path="/pedidos/:id/enviar/previa/:alvo" element={<PreviaEnvio />} />
                <Route path="/pedidos/:id/fechar" element={<FecharPedido />} />
                <Route path="/compromissos" element={<MeusCompromissos />} />
                <Route path="/compromissos/novo" element={<FormCompromisso />} />
                <Route path="/compromissos/:id" element={<FormCompromisso />} />
                <Route path="/metas" element={<Metas />} />
                <Route path="/metas/criador" element={<CriadorDeMetas />} />
                <Route path="/metas/repetir" element={<RepetirMetas />} />
        <Route path="/metas/como-funciona" element={<EmAndamento />} />
                <Route path="/configuracao/metas" element={<ConfiguracaoMetas />} />
                <Route path="/perfil" element={<MeuPerfil />} />
                <Route path="/indique" element={<IndiqueEGanhe />} />
                <Route path="/comissoes" element={<Comissoes />} />
                <Route path="/comissoes/:representadaId" element={<ConferenciaFornecedora />} />
                <Route path="/nao-subiram" element={<NaoSubiram />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
        {/* Fora das rotas: qualquer tela pergunta por ela (confirmar.ts). */}
        <JanelaConfirmacao />
      </AuthProvider>
    </LimiteDeErro>
  )
}
